import { createFileRoute } from '@tanstack/react-router'

import { CourseAddView } from '@/modules/coursesManagement'

export const Route = createFileRoute('/_auth/courses-management/add')({
  component: CourseAddView
})
